const BRANDS = [
  { name: "Carrier", logo: "/assets/RL-Fregrigeracao/carrier.png" },
  { name: "LG", logo: "/assets/RL-Fregrigeracao/lg-new.png" },
  { name: "Samsung", logo: "/assets/RL-Fregrigeracao/samsung-new.png" },
  { name: "Electrolux", logo: "/assets/RL-Fregrigeracao/eletrolux-new.png" },
  { name: "Springer Midea", logo: "/assets/RL-Fregrigeracao/springer-midea.png" },
  { name: "Gree", logo: "/assets/RL-Fregrigeracao/gree.png" },
  { name: "Elgin", logo: "/assets/RL-Fregrigeracao/elgin.png" },
  { name: "Philco", logo: "/assets/RL-Fregrigeracao/philco.png" },
  { name: "Agratto", logo: "/assets/RL-Fregrigeracao/agratto.png" },
  { name: "Danfoss", logo: "/assets/RL-Fregrigeracao/danfoss.png" },
];

export default function Brands() {
  const doubledBrands = [...BRANDS, ...BRANDS];

  return (
    <section
      data-testid="brands-section"
      className="py-16 bg-[#0F172A] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
        <div className="text-center">
          <h2
            data-testid="brands-title"
            className="text-3xl md:text-4xl font-extrabold text-white font-['Barlow_Condensed'] uppercase tracking-tight"
          >
            Trabalhamos Com <span className="text-[#0E86D4]">Todas as Marcas</span>
          </h2>
          <p className="mt-3 text-sm text-slate-400 font-['Manrope']">
            Manutenção e instalação para as principais marcas do mercado
          </p>
        </div>
      </div>

      {/* Scrolling logos */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#0F172A] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#0F172A] to-transparent z-10" />
        <div className="brand-track animate-scroll-brands">
          {doubledBrands.map((brand, idx) => (
            <div
              key={`${brand.name}-${idx}`}
              data-testid={`brand-logo-${idx}`}
              className="flex-shrink-0 bg-white/10 backdrop-blur-sm rounded-sm p-4 flex items-center justify-center min-w-[140px] h-20 hover:bg-white/20 transition-colors"
            >
              <img
                src={brand.logo}
                alt={brand.name}
                className="max-h-12 max-w-[120px] object-contain filter brightness-0 invert"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
